export default require('./theme')

export { default as GlobalStyles } from './GlobalStyles'
